import { LitElement, html, type PropertyValues } from 'lit';
import { toCSSValue } from '@loadsmart/miranda-tokens';

import type { GridProps } from './grid.types';
import { defaultGridProps } from './grid.constants';
import { gridStyles } from './grid.styles';

export class Grid extends LitElement {
	static override styles = [gridStyles()];

	static override get properties() {
		return {
			gap: { type: String },
			rowGap: { type: String, attribute: 'row-gap' },
			columnGap: { type: String, attribute: 'column-gap' },
			minColumnWidth: { type: String, attribute: 'min-column-width' },
		};
	}

	declare gap: GridProps['gap'];

	declare rowGap: GridProps['rowGap'];

	declare columnGap: GridProps['columnGap'];

	declare minColumnWidth: GridProps['minColumnWidth'];

	constructor() {
		super();

		this.gap = defaultGridProps.gap;
		this.minColumnWidth = defaultGridProps.minColumnWidth;
	}

	protected override update(
		changedProperties: PropertyValues<GridProps>,
	): void {
		if (changedProperties.has('gap')) {
			this.style.setProperty(
				'--m-grid-gap',
				(this.gap && toCSSValue(this.gap)) ?? toCSSValue(defaultGridProps.gap),
			);
		}
		if (changedProperties.has('rowGap')) {
			if (this.rowGap) {
				this.style.setProperty('--m-grid-row-gap', toCSSValue(this.rowGap));
			} else {
				this.style.removeProperty('--m-grid-row-gap');
			}
		}
		if (changedProperties.has('columnGap')) {
			if (this.columnGap) {
				this.style.setProperty(
					'--m-grid-column-gap',
					toCSSValue(this.columnGap),
				);
			} else {
				this.style.removeProperty('--m-grid-column-gap');
			}
		}
		if (changedProperties.has('minColumnWidth')) {
			this.style.setProperty(
				'--m-grid-min-column-width',
				this.minColumnWidth || defaultGridProps.minColumnWidth,
			);
		}

		super.update(changedProperties);
	}

	override render() {
		return html`<slot></slot>`;
	}
}

window.customElements.define('m-grid', Grid);

declare global {
	interface HTMLElementTagNameMap {
		'm-grid': Grid;
	}
}
